module.exports = __webpack_public_path__ + "9177076f854e09fa10dd897e41b42ad5.svg";